import {PageLayout, Filters} from '~/components'
import {OrganisationsAdvancedTable} from '~/components/advanced_table'
import {OrganisationsPageHeader} from './page_header'
import {Organisation, BillingActivity} from '@eitje/api'

export const Organisations = () => {
	const organisations = Organisation.useAll({joins: ['environments']})
	const billingActivities = BillingActivity.useAll() //TODO: use joins once this becomes available from BE

	const items = organisations.map(organisation => {
		const organisationBillingActivities = billingActivities.filter(activity =>
			organisation.environment_ids.includes(activity.environment_id),
		)
		const allUserIds = organisationBillingActivities._map('active_user_ids').flat().uniq()

		return {
			...organisation,
			activeUsers: allUserIds.length,
		}
	})

	return (
		<PageLayout
			name="organisations"
			headers={[<OrganisationsPageHeader key={0} />, <Filters key={1} />]}
			filterProps={{items, filters: ['organisation', 'firmStatus']}}
		>
			<OrganisationsAdvancedTable />
		</PageLayout>
	)
}
